export default __webpack_public_path__ + "static/media/Clare 9781408342701.9cacb001.jpg";